module.exports = "<div *ngIf=\"movies\">\n  <h3 class=\"orange-text\">{{title}}</h3>\n  <div class=\"row is-flex\">\n    <div class=\"col-sm-6 col-md-4 col-lg-3 col-xs-6\" *ngFor=\"let movie of movies; let i = index;\">\n      <movie-card [movie]=\"movie\"></movie-card>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/macbookproretina13/Projects/ng5/Movies-Finder/src/app/genres/genres.component.html
// module id = ../../../../../src/app/genres/genres.component.html
// module chunks = main